import companyApi from "../../api/rest/companyApi";

const getAllCompanies = () => async (dispatch) => {
  const res = await companyApi.getAll();
  if (res.data) {
    return res.data;
  }
  return null;
}

const getCompanyById = (companies, companyId) => {
  const company = companies.find(company => company.id === companyId);
  return company
}

export const companyBusiness = {
  getAllCompanies,
  getCompanyById
};